import Layout from "components/Layout";
import CustomRouter from "./Router";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { useEffect, useMemo } from "react";
import {
  getUserLanguage,
  setUserColorThemeMode,
  setUserLanguage,
} from "utils/local-storage";
import { useDispatch } from "react-redux";
import { markUI } from "stores/ui/uiSlice";
import { useAppSelector } from "hooks/store/hooks";
import { selectpaypalClientId } from "stores/auth/authSlice";

function App() {
  // Initialize Redux dispatch function
  // Select values from the Redux store
  const clientId = useAppSelector(selectpaypalClientId)

  const dispatch = useDispatch();

  useEffect(() => {
    // Retrieve stored user preferences or fallback to defaults
    const colorThemeMode = "china_ui";
    const languageMode = getUserLanguage() || "ch";

    // Update UI state with the retrieved preferences
    void dispatch(markUI({ colorThemeMode, language: languageMode }));

    // Store default theme in local storage if it’s not already set

    setUserColorThemeMode("china_ui");
    setUserLanguage(languageMode)

  }, [dispatch]); // Runs once when the component mounts
  // PayPal configuration options

  const initialOptions = useMemo(
    () => ({
      "client-id": clientId,
      currency: "USD",
      intent: "capture",
    }),
    [clientId]
  );
  return (
    <Layout>
      {/* Renders the application's routes inside the main layout */}
      <PayPalScriptProvider options={initialOptions}>
        <CustomRouter />
      </PayPalScriptProvider>
    </Layout>
  );
}

export default App;
